import React from 'react';

export default function renderSponsors(partnerships, noTitle) {
  return partnerships.map(partner => (
    <div className='partners_wrapper' key={`previous_webinars_partnership_${partner.id}`}>
      <p className="webinar_partner_logo">{partner && partner.logo_url && <img src={partner.logo_url} alt="logo" />}</p>
      {!noTitle && <div className="partner_name">{partner && partner.title && <p>{partner.title}</p>}</div>}
    </div>
  ))
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/renderPartners.js